<template>
  <div class="bet-filters">
    <div class="bet-filters__grid">
      <!-- Code filter -->
      <div v-if="!showBetCode" class="bf-field">
        <label class="bf-label">{{ $t('bets.code') }}</label>
        <input
          v-model="localFilters.code"
          type="text"
          class="bf-input"
          :placeholder="$t('bets.code')"
        />
      </div>

      <!-- BetCode filter (short code) -->
      <div v-if="showBetCode" class="bf-field">
        <label class="bf-label">{{ $t('bets.code') }}</label>
        <input
          v-model="localFilters.betCode"
          type="text"
          class="bf-input"
          :placeholder="$t('bets.code')"
        />
      </div>

      <!-- From date -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('generic.from') }}</label>
        <input v-model="localFilters.fromTime" type="date" class="bf-input" />
      </div>

      <!-- To date -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('generic.to') }}</label>
        <input v-model="localFilters.toTime" type="date" class="bf-input" />
      </div>

      <!-- Context filter -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('generic.context') }}</label>
        <select v-model="localFilters.bet_context" class="bf-select">
          <option v-for="opt in contextOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
        </select>
      </div>

      <!-- Type filter -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('bets.type') }}</label>
        <select v-model="localFilters.type" class="bf-select">
          <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
        </select>
      </div>

      <!-- Result filter -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('bets.result') }}</label>
        <select v-model="localFilters.result" class="bf-select">
          <option v-for="opt in resultOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
        </select>
      </div>

      <!-- Payed filter -->
      <div class="bf-field">
        <label class="bf-label">{{ $t('bets.payed') }}</label>
        <select v-model="localFilters.payed" class="bf-select">
          <option v-for="opt in payedOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
        </select>
      </div>
    </div>

    <!-- Only my bets toggle -->
    <div v-if="showOnlyMyBetsToggle" class="bf-toggle">
      <input
        id="only-my-bets"
        v-model="localFilters.onlyPlayedByMe"
        type="checkbox"
        class="bf-checkbox"
        style="accent-color: var(--mybets-primary, #e92742)"
      />
      <label for="only-my-bets" class="bf-toggle__label">
        {{ $t('viewOnlyPerformedByMe') }}
      </label>
    </div>

    <!-- Actions -->
    <div class="bf-actions">
      <button class="bf-btn bf-btn--reset" @click="handleReset">
        {{ $t('generic.reset') }}
      </button>
      <button class="bf-btn bf-btn--search" @click="handleSearch">
        {{ $t('generic.search') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BetFilters',
  props: {
    filters: {
      type: Object,
      required: true
    },
    showBetCode: {
      type: Boolean,
      default: false
    },
    showOnlyMyBetsToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localFilters: Object.assign({}, this.filters)
    };
  },
  computed: {
    contextOptions() {
      return [
        { text: this.capitalize(this.$t('generic.all')), value: '' },
        { text: this.capitalize(this.$t('bets.prematch')), value: 'prematch' },
        { text: this.capitalize(this.$t('bets.live')), value: 'live' },
        { text: this.capitalize(this.$t('bets.mixed')), value: 'mixed' },
        { text: this.capitalize(this.$t('bets.antepost')), value: 'antepost' }
      ];
    },
    typeOptions() {
      return [
        { text: this.capitalize(this.$t('generic.all')), value: '' },
        { text: this.capitalize(this.$t('bets.single')), value: 'single' },
        { text: this.capitalize(this.$t('bets.multiple')), value: 'multiple' },
        { text: this.capitalize(this.$t('bets.integral')), value: 'integral' },
        { text: this.capitalize(this.$t('bets.system')), value: 'system' }
      ];
    },
    resultOptions() {
      return [
        { text: this.capitalize(this.$t('generic.all')), value: '' },
        { text: this.capitalize(this.$t('bets.pending')), value: 'pending' },
        { text: this.capitalize(this.$t('bets.win')), value: 'win' },
        { text: this.capitalize(this.$t('bets.lose')), value: 'lose' },
        { text: this.capitalize(this.$t('bets.void')), value: 'void' },
        { text: this.capitalize(this.$t('bets.cancelled')), value: 'cancelled' }
      ];
    },
    payedOptions() {
      return [
        { text: this.capitalize(this.$t('generic.all')), value: '' },
        { text: this.capitalize(this.$t('generic.yes')), value: 'yes' },
        { text: this.capitalize(this.$t('generic.no')), value: 'no' }
      ];
    }
  },
  watch: {
    filters: {
      handler(newFilters) {
        this.localFilters = { ...newFilters };
      },
      deep: true
    }
  },
  methods: {
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    handleSearch() {
      this.$emit('search', { ...this.localFilters });
    },
    handleReset() {
      const now = new Date();
      const oneMonthAgo = new Date(now.setMonth(now.getMonth() - 1));
      this.localFilters = {
        type: '',
        result: '',
        payed: '',
        code: '',
        betCode: '',
        bet_context: '',
        fromTime: oneMonthAgo.toISOString().substr(0, 10),
        toTime: new Date().toISOString().substr(0, 10),
        onlyPlayedByMe: true
      };
      this.$emit('reset', { ...this.localFilters });
    }
  }
};
</script>

<style scoped>
.bet-filters {
  background-color: var(--mybets-card-bg);
  border-radius: 6px;
  padding: 16px;
  border: 1px solid var(--mybets-border);
}

.bet-filters__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 480px) {
  .bet-filters__grid { grid-template-columns: repeat(2, 1fr); }
}

@media (min-width: 768px) {
  .bet-filters__grid { grid-template-columns: repeat(3, 1fr); }
}

@media (min-width: 1024px) {
  .bet-filters__grid { grid-template-columns: repeat(4, 1fr); }
}

.bf-field {
  display: flex;
  flex-direction: column;
}

.bf-label {
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--mybets-text-muted);
  margin-bottom: 6px;
  text-transform: capitalize;
}

.bf-input,
.bf-select {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.08);
  border: 1px solid var(--mybets-border);
  color: var(--mybets-text);
  font-size: var(--font-size-4xl);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.bf-input:focus,
.bf-select:focus {
  border-color: var(--mybets-primary);
  box-shadow: 0 0 0 2px rgba(233, 39, 66, 0.25);
}

.bf-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='rgba(255,255,255,0.5)'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  padding-right: 32px;
  cursor: pointer;
}

.bf-select option {
  background-color: #2a2a2a;
  color: #ffffff;
}

.bf-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.bf-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid var(--mybets-border);
  cursor: pointer;
}

.bf-toggle__label {
  font-size: var(--font-size-4xl);
  color: var(--mybets-text-muted);
  cursor: pointer;
}

.bf-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.bf-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: var(--font-size-4xl);
  font-weight: 500;
  border: none;
  cursor: pointer;
  text-transform: capitalize;
  transition: background-color 0.15s ease, opacity 0.15s ease, color 0.15s ease;
}

.bf-btn--reset {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--mybets-text);
}

.bf-btn--reset:hover {
  background-color: var(--mybets-primary);
  color: #ffffff;
}

.bf-btn--search {
  background-color: var(--mybets-primary);
  color: #ffffff;
}

.bf-btn--search:hover {
  opacity: 0.9;
}
</style>
